import React from 'react';
import Paper from '@material-ui/core/Paper';
import ProfileCard from 'anchor-ui/profile-card';
import ThemeProvider from 'anchor-ui/theme-provider';
import List from 'anchor-ui/list';
import ListItem from 'anchor-ui/list-item';
import davatar from '../../store/assets/davatar.png';
import calender from '../../store/assets/calender.svg';
import location from '../../store/assets/location.svg';
import AppHeader from 'anchor-ui/app-header';
import AdminBadge from 'anchor-ui/admin-badge';
import personal from '../../store/assets/personal.svg';
import birth from '../../store/assets/birth.svg';



const styles = {
    Paper: {
        height: '100%',
        //borderRight: '1px solid #B5B6B5',
        //borderLeft: '1px solid #B5B6B5',
        backgroundColor: '#FFFFFF',
        square: 'true',
        boxShadow: 'none',
        //borderBottom: '1px solid lightgrey',
      },
    ProfileCard: {
        paddingLeft: '20px',
        //borderBottom: '1px solid #B5B6B5',
    },
    usernameStyle: {
        color: '#251447',
        textAlign: 'left',
        fontFamily: 'Source Sans Pro',
        //'marginLeft': '10px',
        fontWeight: 'normal',
        display: '',
        paddingTop: '17px',
        paddingLeft: '15px',
        fontSize: '25px',
    },
    ProfileIcon: {
        height: '18px',
        marginTop: '-3px',
        //marginLeft: 'px',
        position: 'relative',
        top: '6px',
        paddingLeft: '20px'
    },
    PersonalHeader: {
        //top: '70px',
        marginTop: '40px',
        backgroundColor: '#F3F3F3',
        boxShadow: 'none',
        height: '40px',
    },
    BirthHeader: {
        //top: '150px',
        marginTop: '10px',
        backgroundColor: '#F3F3F3',
        boxShadow: 'none',
        height: '40px',
    },
    MainHeader: {
        //top: '150px',
        //marginLeft: '10px',
        backgroundColor: '#e9e7ec',
        boxShadow: 'none',
        height: '40px',
    },
    TextStyle : {
        color: '#251447',
        //'borderLeft': '2px solid black',
        //'paddingLeft': '16px',
        marginLeft: '2%',
        fontFamily: 'Helvetica Neue',
        fontSize: '18px',
    },
    answerTextStyle : {
        color: '#251447',
        //'borderLeft': '2px solid black',
        //'paddingLeft': '16px',
        marginLeft: '25px',
        fontFamily: 'Sans-serif',
        fontWeight: 'semi-bold',
        fontSize: '16px',
    },
    BirthList: {
        position: 'relative',
        //top: '160px',
        //marginLeft: '3px',
        //paddingLeft: '17px',
    },
    PersonalList: {
        position: 'relative',
        //top: '80px',
        //marginLeft: '3px',
    },
    ListItem: {
        height: '50px',
    },
    primaryPTextStyle: {
        color: '#251447', 
        textAlign: 'left', 
        fontFamily:'Source Sans Pro',
        marginLeft: '7%',
        fontSize: '16px',
        fontWeight: '100',
        lineHeight:'24px',
    },
    primaryBTextStyle: {
        color: '#251447', 
        textAlign: 'left', 
        fontFamily:'Source Sans Pro',
        marginLeft: '6.6%',
        fontSize: '16px',
        fontWeight: '100',
        lineHeight:'24px',
    },
    primaryBWATextStyle: {
        color: '#251447', 
        textAlign: 'left', 
        fontFamily:'Source Sans Pro',
        marginLeft: '19%',
        fontSize: '16px',
        fontWeight: '100',
        lineHeight:'24px',
    },
    rightButtonStyle: {
        marginRight: '5%',
        fontSize: '16px'
    },
    rightPButtonStyle: {
        //position:'fixed', 
        marginLeft: '-530%',
        fontSize: '16px', 
        border: 'off',
        lineHeight: '40px',
        fontFamily: 'Helvetica Neue'
    },
    rightBButtonStyle: {
        //position: 'fixed', 
        marginLeft: '-500%', 
        fontSize: '16px', 
        border: 'off',
        lineHeight: '40px',
        fontFamily: 'Helvetica Neue'
    }
}

class Profile extends React.Component{
    constructor(props) {
        super(props)
    }

    renderDetail = (detail, bst) => {
        return (
          <ThemeProvider color='#251447'>
            <AdminBadge style={bst} text={detail} inverted/>
          </ThemeProvider>
        )
    }

    render() {
        const {avatar, birthCity, birthCountry, birthDate, nepaliDate, birthTime, email, gender, name} = this.props.profile
        
        return (
            <Paper style={styles.Paper}>
            {email ? <div>
            <ThemeProvider color='#F4F4F4'>
                <ProfileCard style={styles.ProfileCard}
                    avatar={avatar? avatar : davatar}
                    username={name || ''}
                    usernameStyle={styles.usernameStyle}
                ></ProfileCard>
            </ThemeProvider>

            <AppHeader style={styles.MainHeader}
                //text="Available Answers"
                //icon={<IconEmoji/>}
                textStyle={styles.answerTextStyle}
                //rightButton={'5'}
                rightButtonStyle={styles.rightButtonStyle}
            />
            <AppHeader style={styles.PersonalHeader}
                text="Personal Information"
                icon={<img src={personal} alt="Personal" style={styles.ProfileIcon}/>}
                textStyle={styles.TextStyle}
            />
            <List style={styles.PersonalList}>
                <ListItem style={styles.ListItem}
                    //primaryText={this.state.uid ? 'Full Name ' + this.state.profile.personal_information.full_name : null}
                    primaryText={'Full Name'}
                    primaryTextStyle={styles.primaryPTextStyle}
                    rightButton = {this.renderDetail(name, styles.rightPButtonStyle)}
                >
                </ListItem>
                <ListItem style={styles.ListItem}
                    //primaryText={this.state.uid ? 'Email ' + this.state.profile.personal_information.email : null}
                    primaryText={'Email'}
                    primaryTextStyle={styles.primaryPTextStyle}
                    rightButton = {this.renderDetail(email, styles.rightPButtonStyle)}
                >
                </ListItem>
                <ListItem style={styles.ListItem}
                    //primaryText={this.state.uid ? 'Gender ' + this.state.profile.personal_information.gender : null}
                    primaryText={'Gender'}
                    primaryTextStyle={styles.primaryPTextStyle}
                    rightButton = {this.renderDetail(gender, styles.rightPButtonStyle)}
                >
                </ListItem>
            </List>
            <AppHeader style={styles.BirthHeader}
                text="Birth Details"
                icon={<img src={birth} alt="Birth" style={styles.ProfileIcon}/>}
                textStyle={styles.TextStyle}
            />
            <List style={styles.BirthList}>
                <ListItem style={styles.ListItem}
                    //primaryText={this.state.uid ? 'Country ' + this.state.profile.birth_details.country : null}
                    primaryText={'Country'}
                    primaryTextStyle={styles.primaryBTextStyle}
                    avatar={location}
                    rightButton = {this.renderDetail(birthCountry, styles.rightBButtonStyle)}
                >
                </ListItem>
                <ListItem style={styles.ListItem}
                    //primaryText={this.state.uid ? 'City ' + this.props.all_data[this.props.all_data.findIndex(x => x.uid == this.props.uid)].birth_details.city: null}
                    primaryText={'City'}
                    primaryTextStyle={styles.primaryBWATextStyle}
                    //avatar='none'
                    rightButton = {this.renderDetail(birthCity, styles.rightBButtonStyle)}
                >
                </ListItem>
                <ListItem style={styles.ListItem}
                    //primaryText={this.state.uid ? 'Date ' + this.state.profile.birth_details.date : null}
                    primaryText={'Date'}
                    primaryTextStyle={styles.primaryBTextStyle}
                    avatar={calender}
                    rightButton = {this.renderDetail(birthDate, styles.rightBButtonStyle)}
                >
                </ListItem>
                <ListItem style={styles.ListItem}
                    //primaryText={this.state.uid ? 'Time ' + this.state.profile.birth_details.time : null}
                    primaryText={'Time'}
                    primaryTextStyle={styles.primaryBWATextStyle}
                    //avatar='none'
                    rightButton = {this.renderDetail(birthTime, styles.rightBButtonStyle)}
                >
                </ListItem>
            </List>
            <AppHeader style={styles.MainHeader}
                text="Other Informations"
                //icon={<img src={birth} alt="Birth" style={styles.ProfileIcon}/>}
                textStyle={styles.TextStyle}
            />
            {nepaliDate? 
            <List style={styles.MainHeader}>
                <ListItem style={styles.ListItem}
                    primaryText={'जन्म मिती'}
                    primaryTextStyle={styles.primaryPTextStyle}
                    rightButton = {this.renderDetail(nepaliDate.day
                        + ' ' + nepaliDate.strMonth
                        + ', ' + nepaliDate.year
                        + ' ' + nepaliDate.strDayOfWeek, 
                        styles.rightBButtonStyle)}
                >
                </ListItem>
            </List>: null}

            </div> : null}
            </Paper>
        )
    }
}

export default Profile;


// WEBPACK FOOTER //
// ./src/Components/Dashboard/Profiles.js